//
//
//
//
//
//
//
//
//
//

export default {
	name: 'MoneyIntention',
};
